<template>
  <v-app id="inspire">

    <!-- <LayoutStructureSuperADM v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel === 25" :listaPermissoes="listaPermissao">
      <router-view></router-view>
    </LayoutStructureSuperADM> -->
  
    <LayoutStructure v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel != 25" :listaPermissoes="listaPermissao">
      <router-view></router-view>
    </LayoutStructure>

    <router-view v-if="!this.$store.getters.isAuthenticated"></router-view>

    <Footer v-if="this.$store.getters.isAuthenticated"></Footer>

  </v-app>
</template>

<script>
import LayoutStructure from './components/LayoutStructure.vue'
// import LayoutStructureSuperADM from './components/LayoutStructureSuperADM.vue'
import Footer from './components/Footer.vue'
import { mapState } from 'vuex';


export default {
  name: 'App',
  components: {
    LayoutStructure,
    // LayoutStructureSuperADM,
    Footer
  },
  computed: {
    ...mapState({
      currentUser: 'currentUser'
    })
  },

  data(){
    return {
      nivel: 'user',
      listaPermissao: JSON.parse(this.$store.getters.listaPermissoes)
    }
  }
  
};
</script>

<style>

  html, body {
    font-size: 1em;
  }

</style>